import React from 'react';
import PropTypes from 'prop-types';

const LanguageButton = ({ id, name, onLanguageSelected }) => (
  <button
    className="language-button"
    type="button"
    onClick={() => onLanguageSelected(id)}
  >
    <div className="flag">
      <img
        src={`${process.env.PUBLIC_URL}/img/${id}-flag.png`}
        alt=""
      />
    </div>
    <div className="language-text">{name}</div>
  </button>
);

LanguageButton.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onLanguageSelected: PropTypes.func.isRequired,
};

export default LanguageButton;
